import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=07fa6d20&"
import script from "@/components/FeedbackList/FeedbackList.ts?vue&type=script&lang=ts&"
export * from "@/components/FeedbackList/FeedbackList.ts?vue&type=script&lang=ts&"
import style0 from "@/components/FeedbackList/feedback-list.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDialog,VFlex,VSelect})
